// 未翻译
export default {
  pageTitle: 'Deposit Payment Record',
  titleText: 'Guarantee Fee List',
  titleOptBtnText: 'Submit Guarantee Fee',
  direction: {
    all: 'All',
    unconfirmed: 'Unconfirmed',
    confirmed: 'Confirmed'
  },
  unconfirmed: 'Unconfirmed',
  confirmed: 'Confirmed',
  // model
  platformReceivingAccount: 'Receiver Account',
  paidAmount: 'Amount',
  paidAmountTips: 'Please submit in multiples of 100',
  currencyUnit: 'Currency Unit',
  transactionSerialNumber: 'Transaction ID',
  transactionSerialNumberTips: 'Please enter the bank or other Transaction ID',
  transferAccount: 'Transfer account',
  transferAccountPlaceholder: 'Please include the account name, account number, and bank or payment method such as: Li Si, ICBC, 6453543533553453',
  tipsTitle: 'Tips',
  tips1: '1. Please confirm the information before submitting because it can\'t be changed',
  tips2: '2. Please transfer money before submitting. The platform will update the store deposit balance once confirms the receipt',
  submitText: 'Submit',
  modelTitleText: 'Submit deposit',

  okTips: 'Cannot be changed after submission, please confirm that the information is correct',
  // search
  submitTime: 'Submit date',
  transferTime: 'Transfer date',
  paymentId: 'Payment ID',
  platformConfirmationStatus: 'Status',
  searchBtnText: 'Search',
  resetBtnText: 'Reset',
  paymentDate: 'Payment date',
  // tb columns
  tbColumns: {
    id: 'Submit ID',
    storeId: 'Store ID',
    transferDate: 'Transfer date',
    paidAmount: 'Payment amount',
    currency: 'Unit',
    statusText: 'Status',
    confirmedAt: 'Confirmation time',
    platformReceivingAccountInfo: 'Platform receiving account',
    transferAccountInfo: 'Transfer account',
    transactionSerialNumber: 'Transaction ID'
  },

  cancelText: 'Cancel',
  okText: 'Confirm'
}
